import styles from "./Subheader.module.scss";
import { useTranslation } from "react-i18next";
import { Instagram, Facebook } from "lucide-react";
import WHCButton from "../WHCButton/WHCButton";
import { useState, useEffect } from "react";

const Subheader = (props) => {
    const { t } = useTranslation();
    const [isScrolled, setIsScrolled] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 50) {
                setIsScrolled(true);
            } else {
                setIsScrolled(false);
            }
        };
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);


    return (
        <div className={`${styles.subheader} ${isScrolled ? styles.scrolled : ""}`}>
            <div className={styles.socialMedia}>
                <a href="https://www.instagram.com/warsawhockeyclub/" target="_blank" rel="noreferrer" >
                    <WHCButton variant="secondary" size="icon-only" icon={Instagram}  />
                </a>
                <a href="https://www.facebook.com/profile.php?id=61577857444718" target="_blank" rel="noreferrer" >
                    <WHCButton variant="secondary" size="icon-only" icon={Facebook} />
                </a>
            </div>
            <span>{t("subheader")}</span>
        </div>
    )
}

export default Subheader;